module.exports = __webpack_public_path__ + "static/media/mascote-homem-aranha@2x.9dc0fcb7.jpg";